import React from "react";
import {
  User,
  Calendar,
  CreditCard,
  Mail,
  Phone,
  MapPin,
  Activity,
  Gauge,
} from "lucide-react";
import { BsSpeedometer } from "react-icons/bs";

const UserInfo = ({ onViewReport, data }) => {
  return (
    <div className="flex flex-col w-full  bg-slate-50/60 border border-slate-200 rounded-xl p-5 md:p-6 shadow-sm">
      <div className="flex justify-between items-center mb-5 gap-2">
        <h3 className="text-xs font-bold text-slate-500 uppercase tracking-widest">
          Customer Profile
        </h3>
        {/* Score Badge */}
        <div className="flex items-center text-nowrap gap-1.5 bg-emerald-50 border border-emerald-200 text-emerald-700 px-2.5 py-1 rounded-full text-3xl font-bold shadow-sm">
          <Gauge size={44} className="text-emerald-600" />
          Score: {data?.score_value}
        </div>
      </div>

      <ul className="w-full flex flex-col space-y-3.5 text-sm">
        {/* Name */}
        <li className="flex justify-between items-center pb-3 border-b border-slate-200/80 text-slate-600">
          <span className="flex items-center gap-2 font-medium">
            <User size={16} className="text-slate-400" />
            Full Name
          </span>
          <span className="font-semibold text-slate-900 capitalize">
            {data?.name?.toLowerCase()}
          </span>
        </li>

        {/* DOB */}
        <li className="flex justify-between items-center pb-3 border-b border-slate-200/80 text-slate-600">
          <span className="flex items-center gap-2 font-medium">
            <Calendar size={16} className="text-slate-400" />
            Date of Birth
          </span>
          <span className="font-semibold text-slate-800">{data?.dob}</span>
        </li>

        {/* PAN */}
        <li className="flex justify-between items-center pb-3 border-b border-slate-200/80 text-slate-600">
          <span className="flex items-center gap-2 font-medium">
            <CreditCard size={16} className="text-slate-400" />
            PAN Number
          </span>
          <span className="font-mono font-semibold text-slate-800 bg-white border border-slate-200 px-2 py-0.5 rounded-md text-xs tracking-wider">
            {data?.pan}
          </span>
        </li>

        {/* Email */}
        <li className="flex justify-between items-center pb-3 border-b border-slate-200/80 text-slate-600">
          <span className="flex items-center gap-2 font-medium">
            <Mail size={16} className="text-slate-400" />
            Email
          </span>
          <span className="font-medium text-slate-800 truncate pl-4">
            {data?.email}
          </span>
        </li>

        {/* Phone */}
        <li className="flex justify-between items-center pb-3 border-b border-slate-200/80 text-slate-600">
          <span className="flex items-center gap-2 font-medium">
            <Phone size={16} className="text-slate-400" />
            Phone
          </span>
          <span className="font-medium text-slate-800">
            {data?.phone && "+91" + data?.phone}
          </span>
        </li>

        {/* Address */}
        <li className="flex flex-col gap-2 pt-1 text-slate-600">
          <span className="flex items-center gap-2 font-medium">
            <MapPin size={16} className="text-slate-400" />
            Registered Address
          </span>
          <span className="text-[13px] leading-snug text-slate-700 bg-white border border-slate-100 p-3 rounded-lg">
            {data?.address}
          </span>
        </li>
      </ul>

      {/* Action Elements Wrapper */}
      {/* <div className="flex items-center gap-3 mt-6 pt-2">
        <button
          type="button"
          onClick={onViewReport}
          className="w-full inline-flex justify-center items-center px-4 py-2.5 text-sm font-semibold text-white bg-slate-900 border border-transparent hover:bg-slate-800 rounded-xl shadow-sm active:scale-[0.99] transition-all duration-150 gap-2"
        >
          Download Full Identity Report
        </button>
      </div> */}
    </div>
  );
};

export default UserInfo;
